<script>
    import {createEventDispatcher, onMount} from 'svelte';
    import CampoDeTexto from "../../UI/CampoDeTexto.svelte";
    import store from '../../../Stores/sede-store';
    import storeMotivos from '../../../Stores/motivos-store';
    import {validaSede} from '../../../Modelos/Sede';
    import Boton from "../../UI/Boton.svelte";
    import Caja from "../../UI/Caja.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import CampoDeSeleccion from "../../UI/CampoDeSeleccion.svelte";

    export let titulo;

    let sede, errores, nombre, error;
    $: sede = $store.sede;
    $: errores = validaSede(sede);
    $: nombre = sede.nombre;

    onMount(() => storeMotivos.cargar());
    $: error = $storeMotivos.error;
    $: motivos = $storeMotivos.listado;

    const dispatch = createEventDispatcher();

    const actualizaCampo = (campo, valor) => store.actualizaCampo(campo, valor);

    const enviaFormulario = () => store.guarda().then(_ => dispatch('enviado'));
    $: console.log(sede);
</script>

<style>
    @media (min-width: 768px) {
        .fila-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: var(--padding-global);
        }
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>{titulo}</Subtitulo>
    </div>

    <form on:submit={enviaFormulario}>
        <div class="fila-3">
            <CampoDeTexto id="nombre" label="Nombre" value={sede.nombre} icono="face"
                          valido={!errores.nombre} mensajeDeError={errores.nombre}
                          on:input={e => actualizaCampo('nombre', e.target.value)}/>
            <CampoDeSeleccion id="entrada" label="Motivo de entrada" value={sede.entrada}
                              valido={!errores.entrada} mensajeDeError={errores.entrada}
                              opciones={motivos.map(x => ({valor: x.id, etiqueta: x.nombre}))} icono="category"
                              on:input={e => actualizaCampo('entrada', parseInt(e.target.value, 0))}/>
            <CampoDeSeleccion id="salida" label="Motivo de salida" value={sede.salida}
                              valido={!errores.salida} mensajeDeError={errores.salida}
                              opciones={motivos.map(x => ({valor: x.id, etiqueta: x.nombre}))} icono="category"
                              on:input={e => actualizaCampo('salida', parseInt(e.target.value, 0))}/>
        </div>
    </form>

    <div slot="pie">
        <Boton type="submit" disabled={Object.keys(errores).length}
               on:click={enviaFormulario}>Guardar
        </Boton>
    </div>
</Caja>